import { render, staticRenderFns } from "./itinerary-detail.vue?vue&type=template&id=443fd7be&scoped=true&"
import script from "./itinerary-detail.vue?vue&type=script&lang=js&"
export * from "./itinerary-detail.vue?vue&type=script&lang=js&"
import style0 from "./itinerary-detail.vue?vue&type=style&index=0&id=443fd7be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443fd7be",
  null
  
)

export default component.exports